import { useEffect, useState, useCallback, useRef } from "react";
import { supabase } from "@/lib/supabase";

export function useSupabaseData<T>(table: string, fallback: T[] = []) {
  const fallbackRef = useRef(fallback);
  fallbackRef.current = fallback;

  const [data, setData] = useState<T[]>(fallbackRef.current);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const mounted = useRef(true);

  const fetchData = useCallback(async () => {
    if (!mounted.current) return;
    setLoading(true);
    setError(null);
    try {
      const { data: result, error: err } = await supabase
        .from(table)
        .select("*")
        .order("created_at", { ascending: false });
      if (err) throw err;
      if (mounted.current) {
        setData((result as T[]) ?? fallbackRef.current);
      }
    } catch {
      if (mounted.current) {
        setError("Error cargando datos");
        setData(fallbackRef.current);
      }
    } finally {
      if (mounted.current) {
        setLoading(false);
      }
    }
  }, [table]);

  useEffect(() => {
    mounted.current = true;
    fetchData();
    return () => {
      mounted.current = false;
    };
  }, [fetchData]);

  return { data, loading, error, refetch: fetchData };
}